// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1218) return "static/css/1218.8ee017ab49876ec93c48.css";
	if (chunkId === 7564) return "static/css/sender.9d87682778d2eee7e59f.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"704":"322f1cc3ca0f05a8be68","981":"9d87682778d2eee7e59f","1412":"83971b4df2c901ec0bdb","4219":"1522f7b39539371e720d","4514":"1522f7b39539371e720d","6877":"322f1cc3ca0f05a8be68","6952":"322f1cc3ca0f05a8be68","8107":"a1717806cb26dd0b7c20","9010":"1522f7b39539371e720d"}[chunkId] + ".chunk.css";
};